import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.initVue();
    }

    initVue(){
        this.app = new Vue({
            el: this.el,
            data: {
                login: false,
                userEmail: false,
                produits: [],
                size: 0,
            },
            mounted() {
                this.get_user();
                if(this.login) this.get_wishlist();
                [...document.querySelectorAll('.snipcart-wishlist, .c-wishlist__modal__bg, .c-wishlist__modal__close, .snipcart-wishlist-add, .snipcart-delete, .c-wishlist__modal__button')].forEach(el => {
                    el.addEventListener('click', (event) => {
                        this.get_wishlist();
                        document.querySelector('html').classList.toggle('c-wishlist--opened');
                    });
                });
            },
            methods: {
                set_event(){

                },
                get_user(){
                    if(Snipcart.store.getState().customer.status != "SignedOut"){
                        fetch("/wp-json/snipcart/v1/user")
                        .then(response => response.json())
                        .then(result => {
                            if(result.email){
                                this.login = true;
                            } else {
                                this.login = false;
                            }
                        })
                    }
                },
                get_wishlist(){
                    fetch("/wp-json/wishlist/get/")
                    .then(response => response.json())
                    .then(data => {
                        this.produits = data;
                        let size = 0;
                        for (let key in data) {
                            if (data.hasOwnProperty(key)) {
                                size++;
                            }
                        }
                        this.size = size;
                    });
                    this.set_event()
                },
                addAllProducts(){
                    let products = this.produits;
                    for (var product in products){
                        if(products[product].instock){
                            this.add_Cart(products[product]);
                        }
                    };
                    this.closeOverlay()
                },
                addCart(event){
                    let product = this.produits[event.target.id]
                    this.closeOverlay()
                    this.add_Cart(product)
                },
                add_Cart(product){
                    try {
                        /*if(product.is_rebate){
                            Snipcart.api.cart.items.add({
                                id: product.variant_id,
                                name: product.title,
                                price: product.old_price,
                                alternatePrices: {
                                    employee: product.employee,
                                    rebate: product.price,
                                },
                                url: product.link,
                                quantity: 1,
                                image: product.image,
                                categories: product.categories.split("|"),
                                maxQuantity: product.max_qty,
                                metadata: {wpid: product.wpid, odooid: product.odoo_id}
                            });
                        } else {*/
                            Snipcart.api.cart.items.add({
                                id: product.variant_id,
                                name: product.title,
                                price: product.price,
                                alternatePrices: {
                                    employee: product.employee,
                                    rebate: product.price,
                                },
                                url: product.link,
                                quantity: 1,
                                image: product.image,
                                categories: product.categories.split("|"),
                                maxQuantity: product.max_qty,
                                metadata: {wpid: product.wpid, odooid: product.odoo_id}
                            });
                        //}
                    } catch (error) {
                        console.log(error)
                    }
                },
                btnRemove(event){
                    this.removeProduct(this.produits[event.target.id]);
                },
                removeProduct(product){
                    let action = "remove"
                    let formData = new FormData()
                    formData.append('pid', product.wpid)
                    fetch("/wp-json/wishlist/"+action,{
                        method: 'POST',
                        body: formData
                    })
                    .then(response => response.json())
                    .then(data => {
                        this.get_wishlist();
                    });
                },
                closeOverlay(){
                    document.querySelector('html').classList.toggle('c-wishlist--opened');
                },
            }
        })
    }
}
